import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import "boxicons/css/boxicons.min.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadingFalse, loadingTrue } from "../Reducer/loaderSlice";
import Handler from "../Helpers/Handler";
import UserIcon from '../Assets/images/user.png';

// toggleSidebar-ah props-ah vangiko machan
const Header = ({ toggleSidebar }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(s => s.customer.customer);
    const [lowStockCount, setLowStockCount] = useState(0);

    return (
        <header className="app-header">
            <div className="header-left" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {/* Burger Menu Button - Mobile-la mattum dhaan CSS-la visibility control aagum */}
                <button className="menu-toggle-btn d-lg-none" onClick={toggleSidebar} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <i className="bx bx-menu fs-2"></i>
                </button>

                <Button onClick={() => navigate('/products/add')} className="add-btn">Add New</Button>
                <Button onClick={() => navigate('/invoices/add')} className="pos-btn">POS</Button>
            </div>

            <div className="header-right">
                <div className="notification-icon" onClick={() => navigate("/lowstock")} style={{ position: "relative", cursor: "pointer" }}>
                    {/* <i className="bx fs-3 bx-bell"></i> */}
                    {lowStockCount > 0 && (
                        <span style={{ position: "absolute", top: "-5px", right: "-8px", background: "#dc3545", color: "#fff", borderRadius: "50%", fontSize: "11px", padding: "2px 6px", lineHeight: "1" }}>
                            {lowStockCount}
                        </span>
                    )}
                </div>
                <Link to='/profile'><img className="user-avatar" src={UserIcon} alt="user" /></Link>
            </div>
        </header>
    );
};

export default Header;